import React, { PureComponent, Fragment } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { Refresh, MoreVert, Toc } from '@material-ui/icons'

export class SourceOptionBase extends PureComponent {
  state = {
    anchorEl: null
  }

  opneSourceBookings = () => {
    const { showModal, sourceId, label } = this.props

    showModal({ type: 'sourceBookings', data: { sourceId, label } })

    this.handleClose()
  }

  handleOpen = e => {
    this.setState({ anchorEl: e.currentTarget })
  }

  handleReset = () => {
    const { resetSource, sourceId } = this.props

    resetSource(sourceId)

    this.handleClose()
  }

  handleClose = () => this.setState({ anchorEl: null })

  render() {
    const { classes } = this.props
    const { anchorEl } = this.state

    return (
      <Fragment>
        <IconButton
          onClick={this.handleOpen}
          className={classes.iconButton}
        >
          <MoreVert fontSize='small' />
        </IconButton>
        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.opneSourceBookings}>
            <ListItemIcon>
              <Toc />
            </ListItemIcon>
            <ListItemText inset primary='Бронювання з системи' />
          </MenuItem>
          <MenuItem onClick={this.handleReset}>
            <ListItemIcon>
              <Refresh />
            </ListItemIcon>
            <ListItemText inset primary='Скинути систему' />
          </MenuItem>
        </Menu>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceOption/SourceOption.js